import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { StyleSheet, View } from "react-native";
import { Image } from "expo-image";

import HeroTitleBar from "./HeroTitle";

import { type EventOverview } from "@/schemas/events/EventOverview";

type Props = {
  event: EventOverview;
};

function HeroImage({ event }: Props): React.JSX.Element {
  const styles = StyleSheet.create({
    container: {
      height: 450,
    },
    image: {
      width: "100%",
      height: "100%",
    },
    gradientContainer: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: "100%",
    },
  });

  return (
    <View style={styles.container}>
      <Image
        source={event.coverImageUri}
        style={styles.image}
        contentFit="cover"
        cachePolicy="memory-disk"
      />
      <View style={styles.gradientContainer}>
        <LinearGradient
          colors={["transparent", "rgba(0,0,0,0.8)"]}
          style={{ flex: 1 }}
        />
      </View>
      <HeroTitleBar event={event} />
    </View>
  );
}

export default HeroImage;
